export enum TrackingCategory {
    ProductList = 'ProductList',
}
